import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { Member, MemberDocument } from '../../api/models/member';
import { DocumentGrid } from '../../shared/documentGrid';
import { RowItem } from '../../shared/miniGrid';
import { UploadFileButton } from '../../shared/uploadFileButton';
import { downloadBase64AsFile } from '../../utils/binaryHelper';
import { useMemberContext } from '../../context/memberContext';

export interface MemberTabProps {
    member: Member | null
}

export default function MemberDocumentTab(props: MemberTabProps) {

    const [documentRows, setDocumentRows] = useState<RowItem[] | undefined>(undefined);

    const { member, updatePersonalPage} = useMemberContext();



    async function initPage() {
        if (props.member && props.member.documents) {
            mapDocumentsToRows(props.member.documents);
        }
    }


    async function mapDocumentsToRows(responseDocuments: MemberDocument[]) {
        if (responseDocuments && responseDocuments.length > 0) {
            const tempRows = responseDocuments.map((doc) => ({
                id: doc.id,
                items: [{ name: 'name', value: doc.name }, { name: 'type', value: doc.documentType }]
            }));

            setDocumentRows(tempRows);
        }
    }


    async function addDocument(selectedFile: string, fileName: string, mimeType: string, size: number, documentType?: string) {


    }

    async function handleDeleteDocument(documentId: string): Promise<boolean> {
        return true;
    }

    async function handleSelectDocument(documentId: string): Promise<boolean> {
        return true;
    }

    return (
        <Grid container spacing={1} style={{ height: '400px' }}>
            <Grid item xs={12} >
                <UploadFileButton selectDocType onChange={addDocument} id={'fileUpload'} /><br />
                {documentRows && <DocumentGrid rows={documentRows} onSelect={handleSelectDocument} onDelete={handleDeleteDocument} />}
            </Grid>
        </Grid>
    )
}